import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import { Mail, Lock } from "lucide-react";
import { useNotification } from "../components/NotificationContext";
import { useAuth } from "../auth/AuthContext";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { login } = useAuth();
  const showNotification = useNotification();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/loginPanel`,
        {
          email,
          password,
        }
      );

      localStorage.setItem("token", response.data.token);
      const { role, id } = response.data;
      localStorage.setItem("role", role);
      localStorage.setItem("id", id);

      login(role);
      showNotification("Giriş başarılı! Hoş geldiniz.", "success");
      navigate("/");
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        "Giriş başarısız! Lütfen bilgilerinizi kontrol edin.";
      setError(message);
      showNotification(message, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen py-12 bg-secondary-light"
    >
      <div className="max-w-md container-custom">
        <div className="p-8 bg-white rounded-lg shadow-medium">
          <h1 className="mb-6 text-2xl font-bold text-gray-dark">Giriş Yap</h1>

          {error && (
            <div className="p-3 mb-4 text-red-600 rounded-md bg-red-50">
              {error}
            </div>
          )}

          <form onSubmit={handleLogin}>
            <div className="mb-4">
              <label htmlFor="email" className="block mb-1 text-gray-dark">
                E-posta
              </label>
              <div className="relative">
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full py-2 pl-10 pr-4 border rounded-md focus:outline-none focus:ring-1 focus:ring-primary"
                  required
                />
                <Mail
                  className="absolute left-3 top-2.5 text-gray"
                  size={18}
                />
              </div>
            </div>

            <div className="mb-2">
              <label htmlFor="password" className="block mb-1 text-gray-dark">
                Şifre
              </label>
              <div className="relative">
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full py-2 pl-10 pr-4 border rounded-md focus:outline-none focus:ring-1 focus:ring-primary"
                  required
                />
                <Lock
                  className="absolute left-3 top-2.5 text-gray"
                  size={18}
                />
              </div>
            </div>

            <div className="flex justify-end mb-6">
              <Link
                to="/forgot-password"
                className="text-sm transition-colors text-primary hover:text-primary-dark"
              >
                Şifremi unuttum
              </Link>
            </div>

            <button
              type="submit"
              className="w-full mb-4 btn-primary"
              disabled={loading}
            >
              {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
            </button>
          </form>

          <p className="text-center text-gray">
            Hesabınız yok mu?{" "}
            <Link
              to="/register"
              className="text-primary hover:text-primary-dark"
            >
              Hemen Kaydolun
            </Link>
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default LoginPage;